/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import { apiUrl, headerconfig } from "../Settings/Config";
import {
  showLoader,
  userID,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
  showContaimerLoader,
} from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
var module = "userroles/";
var moduleName = "User Roles";
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = this.props.location.state?.editID;
    this.state = {
      editID:
        editID !== "" &&
        typeof editID !== undefined &&
        typeof editID !== "undefined"
          ? editID
          : "",
      userID: userID(),
      postdata: {
        roleName: "",
        roleModules: "",
        status: "",
      },
      detaildata: [],
      moduleList: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    this.loadModule();
    if (this.state.editID !== "") {
      var params = {
        params:
          "&userID=" + this.state.userID + "&detail_id=" + this.state.editID,
        url: module + "details",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    console.log(nextProps.formpost, "nextProps.formpost");
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push("/" + module);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.detaildata !== nextProps.detaildata &&
      nextProps.detaildata !== "" &&
      this.state.editID !== ""
    ) {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var roleStatus = result.roleStatus === "A" ? "Active" : "In Active";
          var status =
            result.roleStatus !== "" && result.roleStatus !== null
              ? {
                  label: roleStatus,
                  value: result.roleStatus,
                }
              : "";
          var clientupdatedata = {
            roleName: result.roleName,
            roleModules: result.roleModules,
            status: status,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push("/" + module);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  sateValChange = (field, value) => {};
  loadModule() {
    var urlShringTxt =
      apiUrl + module + "/modulelist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ moduleList: res.data.result });
      }
    });
  }

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;
    console.log(postData.roleModules, "(postData.roleModules");
    var postObject = {
      roleName: postData.roleName,
      roleModules: postData.roleModules,
      status: postData.status?.value || "A",
      userID: this.state.userID,
    };

    var post_url = module + "add";
    if (this.state.editID !== "") {
      postObject["edit_id"] = this.state.editID;
      post_url = module + "update";
    }
    this.props.getFormPost(postObject, post_url, "add");
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="userroles" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={"/" + module}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            moduleList={this.state.moduleList}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop:
                                        $(document)
                                          .find("#modulefrm .error:first")
                                          .offset().top - 100,
                                    },
                                    500
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, postType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, postType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { roleName, status } = props.fields;

  return {
    fields: ["roleName", "status"],
    validations: {
      roleName: [[isEmpty, roleName]],
      status: [[isSingleSelect, status]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
  }

  goBack() {
    this.props.history.push("/" + module);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleCheckAll(type, e) {
    var moduleList = this.props.moduleList;
    var updateduserModule = this.props.fields.roleModules || [];
    if (moduleList.length > 0) {
      moduleList.map((item) => {
        var checkingIndex = updateduserModule?.[item.moduleSlug] || "";
        if (updateduserModule !== "" && checkingIndex !== "") {
          if (e.target.checked === true) {
            updateduserModule[item.moduleSlug].push(type);
          } else {
            var index = updateduserModule[item.moduleSlug].indexOf(type);
            if (index > -1) {
              updateduserModule[item.moduleSlug].splice(index, 1);
            }
          }
        } else {
          updateduserModule[item.moduleSlug] = [];
          updateduserModule[item.moduleSlug].push(type);
        }
      });
    }
    console.log(updateduserModule, "updateduserModule");
    this.props.onChange("roleModules", updateduserModule);
  }
  handleChangeCheckox(fieldName, filedIndex, e) {
    var updateduserModule = this.props.fields.roleModules || [];
    var checkingIndex = updateduserModule?.[filedIndex] || "";
    if (updateduserModule !== "" && checkingIndex !== "") {
      if (updateduserModule[filedIndex].indexOf(fieldName) >= 0) {
        var index = updateduserModule[filedIndex].indexOf(fieldName);
        if (index > -1) {
          updateduserModule[filedIndex].splice(index, 1);
        }
      } else {
        updateduserModule[filedIndex].push(fieldName);
      }
    } else {
      updateduserModule[filedIndex] = [];
      updateduserModule[filedIndex].push(fieldName);
    }
    this.props.onChange("roleModules", updateduserModule);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgroleName,
      errMsgStatus = "";

    if ($validation.roleName.error.reason !== undefined) {
      errMsgroleName = $validation.roleName.show && (
        <span className="error">{$validation.roleName.error.reason}</span>
      );
    }
    if ($validation.status.error.reason !== undefined) {
      errMsgStatus = $validation.status.show && (
        <span className="error">{$validation.status.error.reason}</span>
      );
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-5">
              <label className="form-label">
                Role Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Role Name"
                name="roleName"
                value={fields.roleName}
                {...$field("roleName", (e) =>
                  onChange("roleName", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgroleName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.status}
                onChange={this.handleSelectChange.bind(this, "status")}
                placeholder="Select Status"
                isClearable={true}
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
              />
              {errMsgStatus}
            </div>
          </div>

          <div className="table-responsive">
            <table className="table text-nowrap text-md-nowrap mb-0">
              <thead>
                <tr>
                  <th>Module Name</th>
                  <th>View</th>
                  <th>Add</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td>
                    <label className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        onChange={this.handleCheckAll.bind(this, "view")}
                      />
                      <span className="custom-control-label">Check All</span>
                    </label>
                  </td>
                  <td>
                    <label className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        onChange={this.handleCheckAll.bind(this, "add")}
                      />
                      <span className="custom-control-label">Check All</span>
                    </label>
                  </td>
                  <td>
                    <label className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        onChange={this.handleCheckAll.bind(this, "edit")}
                      />
                      <span className="custom-control-label">Check All</span>
                    </label>
                  </td>
                  <td>
                    <label className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        onChange={this.handleCheckAll.bind(this, "delete")}
                      />
                      <span className="custom-control-label">Check All</span>
                    </label>
                  </td>
                </tr>
                {this.props.moduleList.length > 0 ? (
                  this.props.moduleList.map((item, index) => {
                    var currentModule =
                      fields.roleModules?.[item.moduleSlug] || [];
                    return (
                      <tr key={index}>
                        <td>{item.label}</td>
                        <td>
                          <label className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              onChange={this.handleChangeCheckox.bind(
                                this,
                                "view",
                                item.moduleSlug
                              )}
                              checked={
                                currentModule.indexOf("view") >= 0
                                  ? true
                                  : false
                              }
                            />
                            <span className="custom-control-label"></span>
                          </label>
                        </td>
                        <td>
                          {item.label !== "Dashboard" &&
                            item.label.indexOf("Report") < 0 &&
                            item.label !== "Job Status" && (
                              <label className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  onChange={this.handleChangeCheckox.bind(
                                    this,
                                    "add",
                                    item.moduleSlug
                                  )}
                                  checked={
                                    currentModule.indexOf("add") >= 0
                                      ? true
                                      : false
                                  }
                                />
                                <span className="custom-control-label"></span>
                              </label>
                            )}
                        </td>
                        <td>
                          {item.label !== "Dashboard" &&
                            item.label.indexOf("Report") < 0 &&
                            item.label !== "Job Status" && (
                              <label className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  onChange={this.handleChangeCheckox.bind(
                                    this,
                                    "edit",
                                    item.moduleSlug
                                  )}
                                  checked={
                                    currentModule.indexOf("edit") >= 0
                                      ? true
                                      : false
                                  }
                                />
                                <span className="custom-control-label"></span>
                              </label>
                            )}
                        </td>
                        <td>
                          {item.label !== "Dashboard" &&
                            item.label.indexOf("Report") < 0 &&
                            item.label !== "Job Status" && (
                              <label className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  onChange={this.handleChangeCheckox.bind(
                                    this,
                                    "delete",
                                    item.moduleSlug
                                  )}
                                  checked={
                                    currentModule.indexOf("delete") >= 0
                                      ? true
                                      : false
                                  }
                                />
                                <span className="custom-control-label"></span>
                              </label>
                            )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td className="text-center" colSpan={8}>
                      No {moduleName} Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div
              className="btn-group me-2 sw-btn-group-extra submit_frm"
              role="group"
            >
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                Submit
              </button>

              <button
                className="btn btn-secondary"
                onClick={this.goBack.bind(this)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
